import { api } from "../lib/api";

/**
 * Insights endpoints — derived analytics. Currently only line-item
 * category aggregation. Backend: /app/backend/routes/insights_routes.py
 */
export const insightsService = {
  lineItemCategories: (period = "month", scope = "expense") =>
    api.get("/insights/line-item-categories", { params: { period, scope } }).then((r) => r.data),
  categoryLabels: () => api.get("/insights/category-labels").then((r) => r.data),
};
